<template>
  <div class="seo-page">
    <MetaTags v-if="metaInfo" :meta-info="metaInfo" />
    <div class="seo-page__wrapper">
      <section class="seo-links sale">
        <h2 class="seo-links__title">Myytävät kohteet</h2>
        <ul class="seo-links__list">
          <li v-for="(listing, index) in listings(config.SEARCH_MODES.SALE)" :key="`mode-sale-${index}`">
            <a :href="listing.href">{{ listing.name }}</a>
          </li>
        </ul>
      </section>
      <section class="seo-links rental">
        <h2 class="seo-links__title">Vuokrattavat kohteet</h2>
        <ul class="seo-links__list">
          <li v-for="(listing, index) in listings(config.SEARCH_MODES.RENTAL)" :key="`mode-rental-${index}`">
            <a :href="listing.href">{{ listing.name }}</a>
          </li>
        </ul>
      </section>
      <section class="seo-links rental">
        <h2 class="seo-links__title">OP Kodit paikkakunnittain</h2>
        <ul class="seo-links__list">
          <li v-for="(city, index) in allUniqueOfficeCities" :key="`seo-links-${index}`">
            <a :href="`${agencyRoute.path}/${city.cityId}`">OP Koti {{ city.cityName }}</a>
          </li>
        </ul>
      </section>
    </div>
  </div>
</template>
<script>
import MetaTags from '@/app/components/MetaTags.vue';
import cities from '@/utils/cities-top';
import config from '@/config';
import { filter, uniqBy } from 'lodash-es';
import * as actions from '@/app/store/action-types';
import { agencies as agencyRoute } from '@/app/routes';
import featureGroups from '@/config/featureGroups';
import useOfficesData from '@/app/data/useOfficesData';
import utils from '@/app/utils/utils';

export default {
  name: 'seo',
  setup() {
    const { data: officesData } = useOfficesData();

    return { officesData };
  },
  data: () => ({
    config,
    agencyRoute,
    featureGroups: featureGroups,
  }),
  computed: {
    allUniqueOfficeCities() {
      return uniqBy(
        this.officesData?.map((office) => ({
          cityName: utils.capitalizeMultiPartWords(office.contact.postOffice),
          cityId: office.shortName,
        })),
        (city) => city.cityId
      );
    },
    metaInfo() {
      return {
        title: 'OP Koti - Kohdehakuluettelo',
        meta: [{ name: 'robots', content: 'noindex, follow' }],
      };
    },
  },
  components: {
    MetaTags,
  },
  methods: {
    listings(mode) {
      const list = [];
      let groups = [];

      if (mode === config.SEARCH_MODES.SALE) {
        groups = filter(this.featureGroups, { showInHousingOnSale: true }).map((group) => ({
          pathName: group.pathName,
          name: group.name.toLowerCase(),
        }));
      } else {
        groups = filter(this.featureGroups, { showInRentals: true }).map((group) => ({
          pathName: group.pathName,
          name: group.name.toLowerCase(),
        }));
      }

      groups.forEach((group) => {
        Object.keys(cities).forEach((city) => {
          list.push({
            name: `${mode === config.SEARCH_MODES.SALE ? 'Myytävät' : 'Vuokrattavat'} ${group.name} ${city}`,
            href: `/${mode === config.SEARCH_MODES.SALE ? 'myytavat' : 'vuokrattavat'}/${
              group.pathName
            }/${city.toLowerCase().replace(/ä/g, 'a').replace(/ö/g, 'o')}`,
          });
        });
      });
      return list;
    },
  },
  mounted() {
    void this.$store.dispatch(actions.analytics.set, { pageName: 'kohdehakuluettelo' });
    void this.$store.dispatch(actions.analytics.track, config.analytics.eventTypes.pageView);
  },
};
</script>
